import React, {
  useState,
  useRef,
  useEffect
} from "react";

import {
  useDispatch,
  useSelector
} from "react-redux";

import {
  useHistory
} from "react-router-dom";

import {

  verifyOtpAction,

  verifyEmailAction,

  signupAction,

  loginAction

} from "../../../store/actions/authActions/authActions";
import AuthLayout from "./AuthLayout";

export default function OtpPage() {
const [seconds,
 setSeconds] =
 useState(30);
  const dispatch =
    useDispatch();

  const history =
    useHistory();

 const loading =
     useSelector(
       state =>
         state?.auth?.loading||null
     );

  const {

    verificationId,

    otpPurpose

  } = useSelector(
    state => state.auth
  );

  useEffect(() => {

  if (
    seconds <= 0
  ) return;

  const timer =
    setTimeout(() => {

      setSeconds(
        prev => prev - 1
      );

    }, 1000);

  return () =>
    clearTimeout(timer);

}, [seconds]);
  const [inputs,
    setInputs] =
    useState([
      "",
      "",
      "",
      "",
      "",
      ""
    ]);

  const inputRefs =
    useRef([]);

  /* =========================
     FOCUS
  ========================= */

  useEffect(() => {

    if (
      inputRefs.current[0]
    ) {

      inputRefs.current[0]
        .focus();
    }

  }, []);

  useEffect(() => {

  const otp =
    inputs.join("");

  if (
    otp.length === 6
  ) {

    document
      .getElementById(
        "otp-submit"
      )
      ?.click();
  }

}, [inputs]);

  /* =========================
     OTP INPUT
  ========================= */

 const handleChange = (
  index,
  value
) => {

  const digit =
    value.replace(
      /[^0-9]/g,
      ""
    );

  const newInputs =
    [...inputs];

  newInputs[index] =
    digit;

  setInputs(
    newInputs
  );

  if (
    digit &&
    index < 5
  ) {

    inputRefs.current[
      index + 1
    ]?.focus();
  }
};

const handleKeyDown = (
  index,
  e
) => {

  if (
    e.key ===
    "Backspace"
  ) {

    if (
      !inputs[index] &&
      index > 0
    ) {

      inputRefs.current[
        index - 1
      ]?.focus();
    }
  }
};



  /* =========================
     VERIFY
  ========================= */

  const handleVerify =
    async e => {

      e.preventDefault();

      try {

        const otp =
          inputs.join("");

        await dispatch(

          verifyOtpAction({

            verificationId,

            otp
          })
        );

        /* =====================
           PHONE SIGNUP
        ===================== */

        if (
          otpPurpose ===
          "signup"
        ) {

          const pendingSignup =
            JSON.parse(

              localStorage
                .getItem(
                  "pendingSignup"
                )
            );

          await dispatch(

            signupAction({

              type:
                "phone",

              firstName:
                pendingSignup.firstName,

              lastName:
                pendingSignup.lastName,

              phone:
                pendingSignup.phone,

              verificationId
            })
          );

          localStorage
            .removeItem(
              "pendingSignup"
            );

          history.push(
            "/dashboard"
          );

          return;
        }

        /* =====================
           PHONE LOGIN
        ===================== */

        if (
          otpPurpose ===
          "login"
        ) {

          const pendingLogin =
            JSON.parse(

              localStorage
                .getItem(
                  "pendingLogin"
                )
            );

          await dispatch(

            loginAction({

              type:
                "phone",

              phone:
                pendingLogin.phone,

              verificationId
            })
          );

          localStorage
            .removeItem(
              "pendingLogin"
            );

          history.push(
            "/dashboard"
          );

          return;
        }

        /* =====================
           EMAIL VERIFY
        ===================== */

        if (
          otpPurpose ===
          "email_verification"
        ) {

          await dispatch(

            verifyEmailAction(
              verificationId
            )
          );

          history.push(
            "/dashboard"
          );

          return;
        }

        /* =====================
           FORGOT PASSWORD
        ===================== */

        if (
          otpPurpose ===
          "forgot_password"
        ) {

          history.push(
            "/reset-passwordV2"
          );

          return;
        }

      } catch (error) {

        console.error(
          error
        );
      }
    };

  const handlePaste = e => {

  e.preventDefault();

  const pasted =
    e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, 6);

  if (
    pasted.length
  ) {

    const digits =
      pasted.split("");

    const filled =
      [...Array(6)]
        .map(
          (_, i) =>
            digits[i] || ""
        );

    setInputs(
      filled
    );
  }
};
  return (

  <AuthLayout

  title="Verify Your Account"

  subtitle="Enter the 6-digit verification code we just sent."

>

<p className="otp-target">

  Enter the code sent to
  <br/>
 <strong>

    {
     
         (
            localStorage.getItem(
              "pendingReset"
            ) || "{}"
          )

        
    }

  </strong> 
  <br/>
  
  
  <strong>

    {
      otpPurpose === "login"
        ? JSON.parse(
            localStorage.getItem(
              "pendingLogin"
            ) || "{}"
          )?.phone

        : JSON.parse(
            localStorage.getItem(
              "pendingSignup"
            ) || "{}"
          )?.phone
    }

  </strong>

</p>
        <form
          onSubmit={
            handleVerify
          }
        >

          <div 
 onPaste={
  handlePaste
 }
            className="otp-row"
          >

            {inputs.map(

              (
                value,
                index
              ) => (

                <input
   
 className="otp-input"

                  key={
                    index
                  }

                  ref={el =>
                    inputRefs
                      .current[
                        index
                      ] = el
                  }

                  type="text"

                  maxLength={
                    1
                  }

                  value={
                    value
                  }

                  onChange={
                    e =>
                      handleChange(

                        index,

                        e.target
                          .value
                      )
                  }

                  onKeyDown={e =>
  handleKeyDown(
    index,
    e
  )
}
                />

              )
            )}

          </div>

         <button 
         id="otp-submit"
  className="auth-btn"
 type="submit"
>
 {

              loading
                ?"Verifying..."
                :  "Verify Code"

            }
 

</button>

        </form>

        <div
 className="otp-footer"
>

 Didn't receive code?

 <button
  type="button"
  className="auth-btn"
  disabled={
    seconds > 0
  }
>

  {
    seconds > 0
      ? `Resend in ${seconds}s`
      : "Resend Code"
  }

</button>

</div>
</AuthLayout>
  );
}